import React, { useState } from 'react';
import { Modal, Box, Typography, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import ButtonStyled from '../../../components/general/ButtonStyled';
import { KeyboardArrowRight } from '@material-ui/icons';
import rest from '../../../rest';

const ModalReatribution = ({ setReload, user, open, handleClose, chefOnIds, selectedActivity, sousActivite, ChoixActivites }) => {
    const [newActivity, setNewActivity] = useState(selectedActivity?.id || selectedActivity?.ID || 0);

    const findPosition = (activityId) => {
        let position = -1;
        for (let i = 0; i < ChoixActivites?.length; i++) {
            if (ChoixActivites[i].id === activityId && !ChoixActivites[i].treated) {
                position = i;
                break;
            }
        }
        return position;
    }

    const handelReatribuer = (event) => {
        const position = findPosition(selectedActivity?.id || selectedActivity?.ID);
        rest.post("/benevols/attribution/reattribution.json", {
            idUser: user.ID,
            idActivite: selectedActivity?.id || selectedActivity?.ID || 0,
            newActivity,
            position
        })
        .then((response) => {
            if (response.data.success) {
                setReload(set => !set);
                handleClose(false);
            } else {
                console.error('There was an error to reattribut', response.data);
            }
        })
        .catch(error => {
            handleClose(false);
            console.error('There was an error to reattribut', error);
        });
    };

    const handelSelectNewActivity = (e) => {
        setNewActivity(e.target.value);
    }

    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
        >
            <Box sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 400,
                bgcolor: 'background.paper',
                boxShadow: 24,
                p: 4
            }}>
                <Typography id="modal-title" variant="h6" component="h2">Réattribuer</Typography>
                <FormControl fullWidth sx={{ mt: 2 }}>
                    <InputLabel>{sousActivite}</InputLabel>
                    <Select
                        value={newActivity}
                        onChange={handelSelectNewActivity}
                        displayEmpty
                    >
                        {chefOnIds?.map((activite, index) => (
                            <MenuItem key={index} value={activite.ID}>{activite.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                    <ButtonStyled variant="contained" color="errorBtn" onClick={handleClose} style={{ marginRight: 10 }}>Annuler</ButtonStyled>
                    <ButtonStyled variant="contained" color="primary" onClick={handelReatribuer}><KeyboardArrowRight /></ButtonStyled>
                </Box>
            </Box>
        </Modal>
    );
};

export default ModalReatribution;
